import React from "react";

/**
 * Quill can save visually blank paragraphs as <p><br></p>. Removing only
 * those empty blocks prevents unintended large gaps without altering real
 * article markup.
 */
function cleanRichHtml(html) {
  return String(html || "").replace(
    /<p>(?:\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi,
    ""
  );
}

function FieldNoteDetails({ fieldNote }) {
  const media = Array.isArray(fieldNote.media) ? fieldNote.media : [];
  const galleryClassName = [
    "fieldnote-gallery",
    media.length === 1 ? "fieldnote-gallery--single" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="tab-pane fade show active package-info-tab">
      <div
        className="workshop_bodytext has-bg-image fieldnote-body"
        dangerouslySetInnerHTML={{ __html: cleanRichHtml(fieldNote.body) }}
      />

      {media.length > 0 && (
        <div
          className={galleryClassName}
          aria-label={`Images for ${fieldNote.title}`}
        >
          {media.map((imageUrl, index) => (
            <figure className="fieldnote-gallery-item" key={`${imageUrl}-${index}`}>
              <img
                src={imageUrl}
                alt={`${fieldNote.title} by ${fieldNote.name}, image ${index + 1}`}
                loading="lazy"
              />
            </figure>
          ))}
        </div>
      )}

      <section
        className="fieldnote-biography has-bg-image"
        aria-labelledby="fieldnote-biography-title"
      >
        <h3 id="fieldnote-biography-title" className="d-subtitle has-bg-image">
          About {fieldNote.name}
        </h3>

        <div
          className="workshop_bodytext has-bg-image fieldnote-biography-text"
          dangerouslySetInnerHTML={{ __html: cleanRichHtml(fieldNote.biog) }}
        />

        {fieldNote.link && (
          <a
            className="button-outlined-primary fieldnote-author-link"
            href={fieldNote.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit {fieldNote.name}&apos;s website or profile
            <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
          </a>
        )}
      </section>
    </div>
  );
}

export default FieldNoteDetails;
